import './AttributeGroup.less';
import React, {useState, useEffect} from "react";
import Icon from "../../../../components/icon/Icon";
import Group from "../group/Group";
import __, {translate} from "../../../../i18n";
import getAttributeCheckboxItems from "../utils/getAttributeCheckboxItems";
import isAttributeCheckboxItemSelected from "../utils/isAttributeCheckboxItemSelected";

export default function AttributeGroup(
    {
        attributeGroup,
        attributes,
        selectedAttributeIds = [],
        setSelectedAttributeIds = (selectedAttributeIds) => {},
        defaultCollapsed
    }
) {
    const selectAttributes = (ids) => {
        const newSelectedIds = selectedAttributeIds.concat(ids.filter(id => !selectedAttributeIds.includes(id)));
        setSelectedAttributeIds(newSelectedIds);
    };

    const deselectAttributes = (ids) => {
        setSelectedAttributeIds(selectedAttributeIds.filter(selId => !ids.includes(selId)));
    };

    const checkboxItems = getAttributeCheckboxItems(attributeGroup, attributes);

    return <Group
        title={attributeGroup.name}
        name="attribute"
        defaultCollapsed={defaultCollapsed}
    >
        <ul>
            <li
                className={`${selectedAttributeIds.length === 0 ? 'selected' : ''}`}
                onClick={() => setSelectedAttributeIds([])}
            >
                <Icon name={selectedAttributeIds.length === 0 ? 'checkbox-checked' : 'checkbox-blank'}/>
                <div className="text">{__('All')}</div>
            </li>
            {
                checkboxItems.map((item, index) => {
                    const selected = isAttributeCheckboxItemSelected(item, selectedAttributeIds);

                    return <li
                        key={`${item.name} ${index}`}
                        className={`${selected ? 'selected' : ''}`}
                        onClick={() => selected ? deselectAttributes(item.value) : selectAttributes(item.value)}
                    >
                        <Icon name={selected ? 'checkbox-checked' : 'checkbox-blank'}/>
                        <div className="text">{item.name}</div>
                    </li>;
                })
            }
        </ul>
    </Group>;
}
